import {
  require_web
} from "./chunk-B5ESQCZ3.js";
import {
  SectionElement,
  SectionRenderer,
  Theme,
  defineElement,
  globalOn,
  onClick,
  query
} from "./chunk-SIK2WHDM.js";
import {
  __async,
  __decorateClass,
  __toESM
} from "./chunk-WY5QMTF4.js";

// src/sections/common-cart/common-cart.ts
var import_web = __toESM(require_web());
var CommonCart = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.flipping = new import_web.default({ parent: this, duration: 1e3, easing: "ease" });
  }
  connectedCallback() {
    Theme.Cart.on("updated", () => __async(this, null, function* () {
      yield this.renderAjaxCart();
    }));
  }
  renderAjaxCart() {
    return __async(this, null, function* () {
      const [html, cartTotal] = yield Promise.all([SectionRenderer.renderSection("ajax-cart-page"), SectionRenderer.renderSection("ajax-cart-total")]);
      this.flipping.read();
      this.lineItemsWrapper.innerHTML = html;
      this.cartTotalElm.innerHTML = cartTotal;
      this.flipping.flip();
    });
  }
  startLoading() {
    this.checkoutBtn.setAttribute("loading", "");
  }
  stopLoading() {
    this.checkoutBtn.removeAttribute("loading");
  }
};
__decorateClass([
  query("[data-line-items]")
], CommonCart.prototype, "lineItemsWrapper", 2);
__decorateClass([
  query("[data-cart-total]")
], CommonCart.prototype, "cartTotalElm", 2);
__decorateClass([
  query("[data-checkout]")
], CommonCart.prototype, "checkoutBtn", 2);
__decorateClass([
  globalOn("cart:updated")
], CommonCart.prototype, "renderAjaxCart", 1);
__decorateClass([
  onClick("[data-checkout]"),
  globalOn("cart:startLoading")
], CommonCart.prototype, "startLoading", 1);
__decorateClass([
  globalOn("cart:stopLoading")
], CommonCart.prototype, "stopLoading", 1);
CommonCart = __decorateClass([
  defineElement("common-cart")
], CommonCart);
export {
  CommonCart
};
